import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import dayjs from "dayjs";
const subscriptionsPriceApi = factory.get("subscriptions_price");

const initialState = {
  subscriptions_price_table: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 100,
      page: 0,
      city_id: null,
      month_count: null,
      account_type_id: null,
    },
  },
  subscriptions_price: {
    dialog: false,
    loading: false,
    form: {
      id: null,
      account_type_id: null,
      month_count: 1,
      price: "",
      cities: [],
    },
  },
  new_offer: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      name: null,
      description: null,
      is_active: true,
      account_type_id: null,
      amount: null,
      months_count: null,
      subscriptions_count: null,
      expiry_date: dayjs().format("YYYY-MM-DD"),
      for_new_customers: true,
      for_churn_customers: false,
      for_renewal_customers: false,
      city_id: [],
      note: "",
    },
  },
  offer_expiry_date: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      current_expiry_date: dayjs().format("YYYY-MM-DD"),
      expiry_date: null,
    },
  },
  active_offers_list: {
    loading: false,
    list: [],
  },
};

const variablesSlice = createSlice({
  name: "subscriptionsPrice",
  initialState,
  reducers: {
    setSubscriptionsPriceTable: (state, { payload }) => {
      state.subscriptions_price_table.data = payload.data;
      state.subscriptions_price_table.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.subscriptions_price_table.filters = {
        ...state.subscriptions_price_table.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.subscriptions_price_table.filters =
        initialState.subscriptions_price_table.filters;
    },
    setSubscriptionsPriceDialog: (state, { payload }) => {
      if (payload?.id) {
        state.subscriptions_price.form.id = payload.id;
        state.subscriptions_price.form.cities = payload?.cities || [];
        state.subscriptions_price.form.month_count = payload?.month_count;
        state.subscriptions_price.form.price = payload?.price;
        state.subscriptions_price.form.account_type_id = {
          id: payload?.account_type_id,
          name: payload?.account_type,
        };
      }
      state.subscriptions_price.dialog = !state.subscriptions_price.dialog;
      //clear after close
      if (!state.subscriptions_price.dialog) {
        state.subscriptions_price.form = initialState.subscriptions_price.form;
      }
    },
  },
});

export const {
  setSubscriptionsPriceTable,
  setLoading,
  setDialog,
  setFilters,
  resetFilters,
  setSubscriptionsPriceDialog,
} = variablesSlice.actions;

export default variablesSlice.reducer;

const toNumber = (value) => {
  return typeof value === "number" ? value : parseInt(value.replace(/,/g, ""));
};

export const index = () => async (dispatch, getState) => {
  try {
    const filters =
      getState().subscriptionsPrice.subscriptions_price_table.filters;
    dispatch(setLoading("subscriptions_price_table"));
    const custom_filters = {
      ...filters,
      cabinet_id: filters.cabinet_id?.id || null,
      city_id: filters.city_id?.id || null,
      account_type_id: filters.account_type_id?.id || null,
    };
    const res = await subscriptionsPriceApi.index(custom_filters);
    dispatch(setSubscriptionsPriceTable(res.data));
    dispatch(setLoading("subscriptions_price_table"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors,
        type: "error",
      })
    );
    dispatch(setLoading("subscriptions_price_table"));
    throw new Error(err);
  }
};
export const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("subscriptions_price"));
    const cities = data.cities.map((item) => item.id);
    await subscriptionsPriceApi.create({
      ...data,
      price: toNumber(data.price),
      account_type_id: data.account_type_id?.id,
      cities,
    });

    dispatch(setLoading("subscriptions_price"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setSubscriptionsPriceDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("subscriptions_price"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("subscriptions_price"));
    const cities = data.cities.map((item) => item.id);
    await subscriptionsPriceApi.update(data.id, {
      ...data,
      price: toNumber(data.price),
      account_type_id: data.account_type_id?.id,
      cities,
    });

    dispatch(setLoading("subscriptions_price"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setSubscriptionsPriceDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("subscriptions_price"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const SubscriptionsPriceActions = {
  index,
  create,
  update,
};
